import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Icon,
  Typography,
} from '@mui/material';
import { useTheme, Theme } from '@mui/material/styles';
import React, { FC } from 'react';
import SectionBlock from '@/components/sectionBlock/sectionBlock';

interface IProps {
  label: string;
  initialOpen?: boolean;
  children?: React.ReactNode;
  sectionKey?: string;
}

const useStyles = (theme: Theme) => ({
  root: {
    borderTopColor: `${theme.palette.grey[200]} !important`,
    borderTopWidth: `1px !important`,
    borderTopStyle: 'solid !important',
    padding: '0 !important',
    minHeight: '0px !important',
  },
  content: {
    marginTop: '0!important',
    marginBottom: '0!important',
    justifyContent: 'center !important',
    opacity: '0.4 !important',
    textTransform: 'uppercase',
    fontSize: '1rem !important',
    margin: '0 !important',
    minHeight: '48px!important',
    alignItems: 'center !important',
    // '&.Mui-expanded': {
    //   minHeight: 48,
    // },
  },
  expanded: {
    marginTop: '0!important',
    marginBottom: '0!important',
    // margin: 0,
    minHeight: '48px!important',
  },
  expandIcon: {
    position: 'absolute',
    right: '0 !important',
  },
  title: {
    textTransform: 'uppercase',
    fontSize: '1rem',
    color: 'inherit',
    letterSpacing: 0,
  },
});

/**
 * Abstraction of MUI Accordion.
 * Purpose as a panel for Node settings
 *
 * @link https://v4.mui.com/api/accordion/
 */
export const SettingsPanel: FC<IProps> = ({
  label,
  initialOpen,
  children,
  sectionKey,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Accordion defaultExpanded={initialOpen} sx={classes.expanded}>
      <AccordionSummary
        expandIcon={<Icon>expand_more</Icon>}
        slotProps={{
          root: { sx: classes.root },
          content: { sx: classes.content },
          expandIconWrapper: { sx: classes.expandIcon },
        }}
        sx={classes.expanded}
      >
        {sectionKey ? (
          <SectionBlock
            title={label}
            sectionKey={sectionKey}
            hideBorderAccent
            sectionBoxSx={{ margin: 0 }}
            titleProps={{ variant: 'body1', fontWeight: 400 }}
            titleSx={classes.title}
          />
        ) : (
          <Typography>{label}</Typography>
        )}
      </AccordionSummary>
      <AccordionDetails style={{ padding: '8px 12px 16px' }}>
        <div style={{ width: '100%' }}>{children}</div>
      </AccordionDetails>
    </Accordion>
  );
};
